import { PracticesAction, PracticesActionTypes, PracticesState } from '../types';

export const practices = (state: PracticesState = [], action: PracticesActionTypes) => {
  switch (action.type) {
    case PracticesAction.REPLACE_ALL_PRACTICES:
      return [...action.practices];
    default:
      return state;
  }
};
